var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21528 5.26361C3.09528 6.99306 4.51 8.40778 6.2425 9.28778L7.58694 7.94028C7.755 7.77222 7.99639 7.72333 8.20722 7.79056C8.89167 8.01667 9.62806 8.13889 10.3889 8.13889C10.7281 8.13889 11 8.41083 11 8.75V10.8889C11 11.2281 10.7281 11.5 10.3889 11.5C4.65056 11.5 0 6.84944 0 1.11111C0 0.771944 0.275 0.5 0.611111 0.5H2.75C3.08917 0.5 3.36111 0.771944 3.36111 1.11111C3.36111 1.87194 3.48333 2.60833 3.70944 3.29278C3.77667 3.50361 3.72778 3.745 3.55972 3.91306L2.21528 5.26361Z",
    fill: "#971EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0729169af0d23055a23ad3530f560a9a.svg";
export { ForwardRef as ReactComponent };